// extracted by mini-css-extract-plugin
module.exports = {"readingViewOverflowVerseActionsMenu":"WordActionsMenu_readingViewOverflowVerseActionsMenu__hYXeV","container":"WordActionsMenu_container__fBtQg"};